<template>
  <div>
    <BubbleMenu :editor="editor" v-if="editor">
      <v-btn-toggle dense multiple dark>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 1 })
              .run()
          "
        >
          H1
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 2 })
              .run()
          "
        >
          H2
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 3 })
              .run()
          "
        >
          H3
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleBold()
              .run()
          "
        >
          <v-icon>format_bold</v-icon>
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleItalic()
              .run()
          "
        >
          <v-icon>format_italic</v-icon>
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleUnderline()
              .run()
          "
        >
          <v-icon>format_underline</v-icon>
        </v-btn>
        <v-btn
          @click="
            editor
              .chain()
              .focus()
              .toggleHighlight()
              .run()
          "
        >
          <v-icon>border_color</v-icon>
        </v-btn>
      </v-btn-toggle>
    </BubbleMenu>
    <editor-content :editor="editor" class="editor-field" />
  </div>
</template>

<script>
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Highlight from '@tiptap/extension-highlight'
import Underline from '@tiptap/extension-underline'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Heading from '@tiptap/extension-heading'

export default {
  name: 'Editor',
  components: { EditorContent, BubbleMenu },
  props: ['isEditable', 'content'],
  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Highlight,
        Underline,
        BulletList,
        ListItem,
        OrderedList,
        Heading
      ],
      autofocus: true,
      editorProps: {
        attributes: {
          class: 'format-editor'
        }
      },
      content: this.content || '',
      editable: this.isEditable
    })
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  data: () => ({
    editor: null
  }),
  methods: {
    getContent() {
      this.comment = this.editor.getHTML()
      return this.comment
    },
    clearContent() {
      this.editor.commands.clearContent()
    }
  },
  watch: {
    isEditable(value) {
      this.editor.setOptions({
        editable: value,
        isReadonly: !value
      })
    },
    content(value) {
      this.editor.setOptions({
        content: value
      })
    }
  }
}
</script>
<style lang="scss">
.format-editor {
  margin: 0;
  padding: 5px;
  border-radius: 7px;
}
.ProseMirror {
  highlight {
    color: '#9633DF';
  }
}
</style>
